export const selectCurrentAuthOnboardingStep = (state: IState) => state.userAuthOnboarding.currentOnboardingStep
